import React from 'react';

const GroupContext = React.createContext();

export default GroupContext;
